<template>
  <ProductFilterLoader v-if="loading" />
  <div v-else @click="$emit('sectionClick', 'filter')">
    <div @click="$emit('sectionClick', 'filter')">
      <aside class="product-filter">
        <h4 v-if="showTitle" class="filter-title">{{ title }}</h4>
        <section v-if="categories.length || Object.keys(categories).length" class="filter-categories">
          <h5>Categories</h5>
          <ul v-if="Array.isArray(categories)" class="parent-category">
            <li v-if="!showTitle" :class="{ 'active-nav': currentURL === $route.fullPath }">
              <router-link :to="currentURL">All Products</router-link>
            </li>
            <li
              v-for="(category, index) in categories"
              :key="category && category._id"
              @click.prevent="onOpenCategoryChild(index)"
            >
              <a href="javascript:void()" @click.prevent="(e) => onCategoryClick(e, index, category)">
                <span>{{ category.name }}</span>
              </a>
              <ul
                v-if="category.children && category.children.length"
                class="parent-category child-category"
                :class="{ active: index === activeCategoryIndex }"
              >
                <li
                  v-for="childCategory in category.children"
                  :key="childCategory && childCategory._id"
                  :class="{ 'active-nav': childCategory._id == queryString.category }"
                >
                  <a href="javascript:void()" @click.prevent="(e) => onCategoryClick(e, Number.NaN, childCategory)">
                    <span>{{ childCategory.name }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul v-else class="parent-category">
            <li
              v-for="(category, index) in categories.children"
              :key="category && category._id"
              @click="onOpenCategoryChild(index)"
            >
              <span @click.prevent="(e) => onCategoryClick(e, index, category)">{{ category.name }}</span>
              <ul
                v-if="category.children && category.children.length"
                class="parent-category child-category"
                :class="{ active: index === activeCategoryIndex }"
              >
                <li
                  v-for="childCategory in category.children"
                  :key="childCategory && childCategory._id"
                  :class="{ 'active-nav': childCategory.my_soco_sql_id == $route.params.category_id }"
                >
                  <a href="javascript:void()" @click="(e) => onCategoryClick(e, Number.NaN, childCategory)">
                    <span>{{ childCategory.name }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </section>
        <section class="filter-availability">
          <h5>Availability</h5>
          <ul class="parent-availability">
            <li v-for="availability in options.availabilities" :key="availability">
              <input
                :id="availability"
                v-model="selectedAvailable"
                class="checkbox"
                type="checkbox"
                name="availability"
                :value="availability"
                @change="applyAvailable"
              />
              <label :for="availability">{{ availabitiesLabel(availability) }}</label>
            </li>
          </ul>
        </section>
        <section v-if="$route.name !== 'BrandDetail'" class="filter-brands">
          <h5>Brands</h5>
          <div class="filter-brands-wrapper">
            <ul class="filter-brands-tab">
              <li
                v-for="(brandOption, index) in options.brands.tab"
                :key="brandOption"
                :class="{ active: index === activeBrandsTabIndex }"
                @click="activeBrandsTabIndex !== index ? (activeBrandsTabIndex = index) : null"
              >
                {{ brandsTabLabel(brandOption) }}
              </li>
            </ul>
            <div class="filter-brands-input">
              <input v-model="searchBrand" type="text" class="form-control" placeholder="Search..." />
            </div>
            <div class="filter-brands-options">
              <template v-if="brands_filter.length">
                <ul>
                  <li v-for="(brand, key) in brands_filter" :key="'bran-' + key">
                    <input
                      v-if="activeBrandsTabIndex === 0"
                      :id="`filterbrand-${brand['_id']}`"
                      v-model="selectedBrand"
                      class="checkbox"
                      type="checkbox"
                      :value="brand['_id']"
                      name="filterbrand"
                      @change="applyBrand"
                    />
                    <input
                      v-else
                      :id="`filterbrand-${brand['_id']}`"
                      v-model="selectedOrigin"
                      class="checkbox"
                      type="checkbox"
                      :value="brand['country_tag_id']"
                      name="filterbrand"
                      @change="applyBrand"
                    />
                    <img v-if="activeBrandsTabIndex === 1" :src="brand.flag" class="flag-origin" />
                    <label :for="`filterbrand-${brand['_id']}`">{{
                      activeBrandsTabIndex === 0 ? brand.name.toUpperCase() : brand.country.toUpperCase()
                    }}</label>
                  </li>
                </ul>
              </template>
              <div v-else-if="Array.isArray(brands_filter) && !brands_filter.length" style="margin-bottom: 20px">
                No Result Found
              </div>
            </div>
          </div>
        </section>
        <section class="filter-ratings">
          <h5>Ratings</h5>
          <ul class="list">
            <li class="list__item">
              <label class="radio-donut">
                <input v-model="filterRating" type="radio" name="rating_desktop" value="5" @change="applyRating" />
                <GRatingInline average-rating="5.0" star-fill-number="50" />
                <span></span>
              </label>
            </li>
            <li class="list__item">
              <label class="radio-donut">
                <input v-model="filterRating" type="radio" name="rating_desktop" value="4" @change="applyRating" />
                <GRatingInline average-rating="4.0" star-fill-number="40" />
                <span></span>
              </label>
            </li>
            <li class="list__item">
              <label class="radio-donut">
                <input v-model="filterRating" type="radio" name="rating_desktop" value="3" @change="applyRating" />
                <GRatingInline average-rating="3.0" star-fill-number="30" />
                <span></span>
              </label>
            </li>
            <li class="list__item">
              <label class="radio-donut">
                <input v-model="filterRating" type="radio" name="rating_desktop" value="2" @change="applyRating" />
                <GRatingInline average-rating="2.0" star-fill-number="20" />
                <span></span>
              </label>
            </li>
            <li class="list__item">
              <label class="radio-donut">
                <input v-model="filterRating" type="radio" name="rating_desktop" value="1" @change="applyRating" />
                <GRatingInline average-rating="1.0" star-fill-number="10" />
                <span></span>
              </label>
            </li>
            <li class="list__item">
              <label class="radio-donut">
                <input v-model="filterRating" type="radio" name="rating_desktop" value="0" @change="applyRating" />
                <GRatingInline average-rating="0.0" star-fill-number="0" />
                <span></span>
              </label>
            </li>
          </ul>
        </section>
        <section v-if="bpSkinHair.length > 0 || bpConcern.length > 0" class="filter-brands">
          <h5>Beauty Profile</h5>
          <div class="filter-brands-wrapper">
            <div class="filter-brands-options filter-bp">
              <template v-if="bpSkinHair.length">
                <p class="filter-bp-subtitle">Jenis Kulit</p>
                <ul v-if="bpSkinHair.length > 0">
                  <li v-for="(bp, key) in bpSkinHair" :key="'bpSH-' + key">
                    <input
                      v-if="activeBrandsTabIndex === 0"
                      :id="`filterbp-${bp['_id']}`"
                      v-model="selectedBeautyProfile"
                      class="checkbox"
                      type="checkbox"
                      :value="bp['_id']"
                      name="filterbp"
                      @change="applyBeautyProfile"
                    />
                    <label :for="`filterbp-${bp['_id']}`">{{ bp.name }}</label>
                  </li>
                </ul>
              </template>
              <template v-if="bpConcern.length">
                <p class="filter-bp-subtitle">Kondisi Kulit</p>
                <ul v-if="bpConcern.length > 0">
                  <li v-for="(bp, key) in bpConcern" :key="'bpC-' + key">
                    <input
                      v-if="activeBrandsTabIndex === 0"
                      :id="`filterbp-${bp['_id']}`"
                      v-model="selectedBeautyProfile"
                      class="checkbox"
                      type="checkbox"
                      :value="bp['_id']"
                      name="filterbp"
                      @change="applyBeautyProfile"
                    />
                    <label :for="`filterbp-${bp['_id']}`">{{ bp.name }}</label>
                  </li>
                </ul>
              </template>
            </div>
          </div>
        </section>
        <section v-if="showClearAllButton" class="list-reset">
          <button type="button" class="btn btn--black" @click.prevent="reset">Clear all</button>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductFilter',
  components: {
    ProductFilterLoader: () => import('@/components/global/loader/product-filter-loader'),
  },
  props: {
    title: {
      type: String,
      default: 'All Products',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    categorySqlId: {
      type: Number,
      default: 0,
    },
    parentCategory: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        availabilities: ['is_active_in_sociolla', 'is_active_in_lulla'],
        brands: {
          tab: ['name', 'origins'],
          name: [],
          origins: [],
        },
      },
      selected: {
        availabilities: null,
      },
      currentURL: `${window.location.pathname}`,
      availabitiesLabel: (option) => {
        switch (option) {
          case 'is_active_in_lulla':
            return 'Available at Lilla';
          case 'is_active_in_sociolla':
            return 'Available at Sociolla';
          default:
            return option;
        }
      },
      brandsTabLabel: (option) => {
        switch (option) {
          case 'name':
            return 'Brand Name';
          case 'origins':
            return "Brand's Origins";
          default:
            return option;
        }
      },
      activeCategoryIndex: null,
      activeBrandsTabIndex: 0,
      searchBrand: '',
      selectedBrand: [],
      selectedOrigin: [],
      filterRating: '',
      selectedAvailable: [],
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
          minWidth: '12px',
        },
      },
      bpConcern: [],
      bpSkinHair: [],
      selectedBeautyProfile: [],
    };
  },
  computed: {
    categories() {
      if (this.isBrandPage) {
        return this.$store.state['$_Brand'].categories;
      } else if (this.isCategoryPage) {
        return this.$store.state['$_Category'].grandParent;
      } else {
        return this.$store.state['$_Review'].categories;
      }
    },
    showClearAllButton() {
      return (
        this.clickedSection === 'filter' ||
        this.$route.query.category ||
        this.$route.query.brands ||
        this.$route.query.origins ||
        this.$route.query.rating ||
        this.$route.query.available_for
      );
    },
    brands_filter: {
      get: function () {
        let data = [];
        let key = '';
        if (this.activeBrandsTabIndex === 1) {
          data =
            this.$route.name === 'Category'
              ? this.$store.state['$_Category'].brand_origin
              : this.$store.state['$_Review'].countryList;
          key = 'country';
        } else {
          data =
            this.$route.name === 'Category'
              ? this.$store.state['$_Category'].brand
              : this.$store.state['$_Review'].brandList;
          key = 'name';
        }

        // Ensure data is an array to prevent "data.filter is not a function" error
        if (!Array.isArray(data)) {
          data = [];
        }

        if (this.searchBrand) {
          return data.filter((brand) => {
            const data = brand[key] || '';
            return data.toLowerCase().indexOf(this.searchBrand.toLowerCase()) >= 0;
          });
        } else {
          return data;
        }
      },
      set: function (data) {
        this.$store.commit('$_Review/SET_LIST_BRAND_FILTER', data);
      },
    },
    listSelectedBrand() {
      const filterBrands = [];
      if (this.brands_filter.length) {
        let key = 'selectedBrand';
        let label = '_id';
        if (this.activeBrandsTabIndex === 1) {
          key = 'selectedOrigin';
          label = 'country_tag_id';
        }
        this[key].map((x) => {
          const data = this.brands_filter.filter((xx) => xx[label] === x);
          if (data.length) {
            filterBrands.push(data[0]);
          }
        });
      }
      return filterBrands;
    },
    queryString() {
      return this.$store.state.$_Review.queryString;
    },
    loading() {
      const { $_Category, $_Brand } = this.$store.state;
      if (this.isBrandPage) {
        return Boolean($_Brand.loading);
      }
      if (this.isCategoryPage) {
        return Boolean($_Category.loading);
      }
      return false;
    },
    isBrandPage() {
      return this.$route.name === 'BrandDetail';
    },
    isCategoryPage() {
      return this.$route.name === 'Category';
    },
  },
  watch: {
    '$route.path'() {
      Object.entries(this.$options.data()).forEach(([key, value]) => (this[key] = value));
    },
    '$route.params'() {
      if (this.checkParentCategory()) {
        this.getBeautyProfile();
      }
    },
    $route(to, from) {
      if (to != from) {
        if (this.$route.query.brands) {
          this.selectedBrand = this.$route.query.brands.split(',');
        } else {
          this.selectedBrand = [];
        }
        if (this.$route.query.tags) {
          this.selectedBeautyProfile = this.$route.query.tags.split(',');
        } else {
          this.selectedBeautyProfile = [];
        }

        if (this.$route.query.origins) {
          this.selectedOrigin = this.$route.query.origins.split(',');
        } else {
          this.selectedOrigin = [];
        }

        if (this.$route.query.available_for) {
          this.selectedAvailable = this.$route.query.available_for.split(',');
        } else {
          this.selectedAvailable = [];
        }

        if (this.$route.query.rating) {
          this.filterRating = this.$route.query.rating;
        } else {
          this.filterRating = '';
        }

        if (this.$route.query.category) {
          this.filterCategory = this.$route.query.category;
        } else {
          this.filterCategory = '';
        }
      }
    },
    '$store.state.$_Category.tag'() {
      if (this.checkParentCategory()) {
        this.getBeautyProfile();
      }
    },
  },
  created() {
    this.getCategoriesChildren();
    this.getBrandsOrigin();
    this.getBrandsLetter();
    // this.getBeautyProfile();
    if (this.$route.query.brands) {
      this.selectedBrand = this.$route.query.brands.split(',');
    }

    if (this.$route.query.tags) {
      this.selectedBeautyProfile = this.$route.query.tags.split(',');
    }

    if (this.$route.query.origins) {
      this.selectedOrigin = this.$route.query.origins.split(',');
    }

    if (this.$route.query.available_for) {
      this.selectedAvailable = this.$route.query.available_for.split(',');
    }

    if (this.$route.query.rating) {
      this.filterRating = this.$route.query.rating;
    }
  },
  methods: {
    async getCategoriesChildren() {
      if (this.categorySqlId) {
        this.$store.dispatch('$_Review/getCategoriesChildren', this.categorySqlId);
      } else {
        this.$store.dispatch('$_Review/getCategoriesChildren');
      }
    },
    async getBrandsOrigin() {
      if (this.categorySqlId) {
        this.$store.dispatch('$_Review/getBrandsOrigin', this.categorySqlId);
      } else {
        this.$store.dispatch('$_Review/getBrandsOrigin');
      }
      this.getBeautyProfile();
    },
    async getBrandsLetter() {
      if (this.categorySqlId) {
        this.$store.dispatch('$_Review/getBrandsLetter', this.categorySqlId);
      } else {
        this.$store.dispatch('$_Review/getBrandsLetter');
      }
    },
    onOpenCategoryChild(index, force = false) {
      this.activeCategoryIndex = force ? index : this.activeCategoryIndex === index ? null : index;
    },
    onCategoryClick(event, index, data) {
      event.stopPropagation();
      if (!Number.isNaN(index)) {
        this.onOpenCategoryChild(index, true);
      }
      if (this.$route.name === 'Category') {
        this.$router.push(`/category/${data.my_soco_sql_id}/${data.link_rewrite}`);
        this.$nextTick(() => {
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'category',
            value: data._id,
          });
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'category',
          value: data._id,
        });
      }
    },
    applyBrand() {
      let brandQuery = '';
      let brandQueryOrigin = '';

      brandQuery = this.selectedBrand.join();
      brandQueryOrigin = this.selectedOrigin.join();

      if (this.selectedBrand && this.selectedBrand.length) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'brands',
          value: brandQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'brands',
          value: '',
        });
      }

      if (this.selectedOrigin && this.selectedOrigin.length) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'origins',
          value: brandQueryOrigin,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'origins',
          value: '',
        });
      }
    },
    applyRating() {
      if (this.filterRating) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'rating',
          value: this.filterRating,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'rating',
          value: '',
        });
      }
    },
    applyAvailable() {
      const availableQuery = this.selectedAvailable.join();
      if (this.selectedAvailable) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'available_for',
          value: availableQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'available_for',
          value: '',
        });
      }
    },
    getRandomPercentage(min = 40, max = 100) {
      return `${min + Math.random() * (max - min)}%`;
    },
    reset() {
      this.selectedOrigin = [];
      this.selectedBrand = [];
      this.filterCategory = '';
      this.selectedAvailable = [];
      this.filterRating = '';
      this.selectedBeautyProfile = [];

      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'category',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'brands',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'origins',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'available_for',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'rating',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'tags',
        value: '',
      });
      // this.$router.push(`/our-curated-selection`);
    },
    async getBeautyProfile() {
      try {
        const data = this.$store.state.$_Category.tag;
        if (Array.isArray(data)) {
          this.bpSkinHair = data.filter((item) => item.level_name === 'Skin/Hair Type');
          this.bpConcern = data.filter((item) => item.level_name === 'Concern');
        } else {
          this.bpSkinHair = [];
          this.bpConcern = [];
        }
      } catch (error) {
        console.error(error);
        this.bpSkinHair = [];
        this.bpConcern = [];
      }
    },
    applyBeautyProfile() {
      const bpQuery = this.selectedBeautyProfile.join();
      if (this.selectedBeautyProfile && this.selectedBeautyProfile.length) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'tags',
          value: bpQuery,
        });
      } else {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'tags',
          value: '',
        });
      }
    },
    checkParentCategory() {
      const ALLOWED_PARENT_CAT = [
        '5d3d50276b24d01599516819', // Skin care (Main Parent)
        '5dbb1374ca096d5a008cefd8', // Cleanser
        '5dbb1374ca096d5a008cefd2', // Moisturizer,
        '5e995c83ffc8145362158c35', // Sun Care,
        '5dbb1374ca096d5a008cefdd', // Other
        '5d3d50276b24d01599516818', // Makeup (Main Parent)
        '5d3d50276b24d01599516820', // Face
        '5d3d502437382b158ee6dda2', // Eyes
        '5d3ac309a6992471b7c97f78', // Lips
        '5e99bbc58fd3300de3b1dbd5', // Makeup & Pallete Set
      ]; // Add this if needed
      return ALLOWED_PARENT_CAT.some((value) => this.parentCategory.includes(value));
    },
  },
};
</script>

<style lang="scss" scoped>
.active-nav {
  background-color: #fff3f3;
  font-weight: bold;
}
@mixin checkbox() {
  display: flex;
  align-items: center;
  gap: 12px;
  input.checkbox {
    cursor: pointer;
    margin: 0;
    height: 16px;
    width: 16px;
    &::after {
      border: 1px solid $greylight;
      height: 16px;
      width: 16px;
      top: 0;
    }
    &:checked {
      &::after {
        border: 1px solid#f285a6;
      }
    }
  }
  label {
    cursor: pointer;
    width: 100%;
    font: 14px/22px $lato_regular;
    letter-spacing: 0;
    text-align: left;
    margin: 0;
    text-transform: capitalize;
  }
}
aside.product-filter {
  width: 232px;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1803921568627451);
  background-color: $white;
  > h4.filter-title,
  section {
    padding: 16px 12px;
  }
  > section > h5 {
    font: 16px/22px $lato_bold;
    letter-spacing: 0;
    text-align: left;
    margin: 0;
    margin-bottom: 12px;
  }
  h4.filter-title {
    font: 20px/24px $lato_bold;
    letter-spacing: 0;
    text-align: left;
    margin: 0;
    border-bottom: 1px solid $greylight;
  }
  section.filter-categories {
    border-bottom: 1px solid $greylight;
    ul.parent-category {
      margin-bottom: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;
      > li {
        cursor: pointer;
        position: relative;
        padding: 3px 8px;
        font: 14px/22px $lato_regular;
        letter-spacing: 0;
        text-align: left;
        color: $black;
        &:has(ul.child-category) {
          &::after {
            content: url('/assets/img/arrow-down-grey.svg');
            transition: transform 0.4s ease-in;
            transform: rotate(0deg);
            position: absolute;
            right: 0;
            top: 0;
          }
        }
        &:has(ul.child-category.active) {
          &::after {
            transform: rotate(180deg);
          }
        }
      }
    }
    ul.child-category {
      max-height: 0;
      transition: all 0.4s ease-in;
      overflow: hidden;
      &.active {
        max-height: 250px;
        margin-top: 8px;
      }
    }
  }
  section.filter-availability {
    border-bottom: 1px solid $greylight;
    ul.parent-availability {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 0;
      > li {
        @include checkbox();
      }
    }
  }
  section.filter-brands {
    border-bottom: 1px solid $greylight;
    div.filter-brands-wrapper {
      display: flex;
      flex-direction: column;
      gap: 12px;
      ul.filter-brands-tab {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        font: 10px/13px $lato_bold;
        text-align: center;
        color: #aab1ba;
        > li {
          cursor: pointer;
          flex: 1;
          padding-bottom: 8px;
          border-bottom: 2px solid $greylight;
          &.active {
            color: $black;
            border-bottom-color: $red;
          }
        }
      }
      div.filter-brands-input {
        position: relative;
        > input[type='text'] {
          height: 38px;
          border-radius: 4px;
        }
        &::after {
          content: '';
          position: absolute;
          right: 11px;
          top: 11px;
          z-index: 10;
          background-size: cover;
          width: 15px;
          height: 15px;
          background-position: 50%;
          background-repeat: no-repeat;
          background-image: url(/assets/img/icons/search.svg);
          display: block;
        }
      }
      .filter-brands-options {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 0;
        max-height: 256px;
        overflow-y: scroll;
        margin-bottom: 12px;
        .list-inline {
          padding-left: 0;
          margin-left: -5px;
          list-style: none;
          > li {
            display: inline-block;
            padding-right: 5px;
            padding-left: 5px;
          }
        }
        .pill {
          background: #f384a7;
          height: 32px;
          margin-right: 0;
          margin-top: 8px;
          display: inline-flex;
          padding: 0 8px;
          color: #ffffff;
          white-space: nowrap;
          letter-spacing: normal;
          font: 13px/16px 'Lato', sans-serif;
          border-radius: 16px;
          align-items: center;
          text-transform: capitalize;
        }
        .pill-dismiss {
          cursor: pointer;
          font-style: normal;
          margin-left: 8px;
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url('/assets/img/iconCloseLabel.svg') transparent no-repeat 50%;
          background-size: 14px 14px;
        }
        ul {
          > li {
            @include checkbox();
            margin: 0 0 12px;
            .flag-origin {
              width: 20px;
              height: 14px;
              margin-left: 10px;
              object-fit: contain;
            }
          }
        }
      }
    }
  }

  section.filter-ratings {
    border-bottom: 1px solid $greylight;
    .list {
      margin: 0;
      padding: 0;
      .list__item {
        margin-bottom: 10px;
        font: 14px/22px 'lato-regular', sans-serif;
        ::v-deep .rate-star--uniform {
          span {
            height: 16px;
            width: 18px;
            background-size: 16px 16px;
            &:before {
              height: 16px;
              background-size: 16px 16px;
            }
          }
        }
        ::v-deep .card-average-rating {
          font: 14px/18px 'lato-bold', sans-serif;
        }
      }
    }
  }

  section.list-reset {
    text-align: center;
    .btn {
      width: 100%;
      box-sizing: border-box;
    }
  }
  .filter-bp-subtitle {
    color: #8c8582;
    font: 700 12px 'lato-regular';
  }
  .filter-bp {
    max-height: 100% !important;
    overflow-y: hidden !important;
  }
}
</style>
